
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import { ensureReportAuth } from './core/reportAuth'
const DEBI_TYPES = [ //DEBI
    'DPSRRS',
    'OFRS', 
    'OFES',
    'RPRS',
    'VAS'
] as const;
  
// เพิ่ม interface สำหรับ type safety
interface EngagementData {
    company: string;
    companyId: string;
    email: string;
    date: string;
    team: string;
    [key: string]: any; // สำหรับ dynamic properties เช่น OFES_total, OFES_answer
}
  
interface ProcessedEngagementItem {
    company: string;
    email: string;
    total: number;
    answer: number;
    date: string;
    type: string;
    team: string;
}
  
const processEngagementData = (rawData: EngagementData[]): Record<string, ProcessedEngagementItem> => {
    const engagementIndexDay: Record<string, ProcessedEngagementItem> = {};

    for (const data of Object.values(rawData)) {
        for (const type of DEBI_TYPES) {
        const key = `${data.company}-${data.email}-${type}-${data.date}`;
        
        engagementIndexDay[key] = {
            company: data.company,
            email: data.email,
            total: data[`${type}_total`] || 0,
            answer: data[`${type}_answer`] || 0,
            date: data.date,
            type,
            team: data.team
        };
        }
    }

    return engagementIndexDay;
}

const baseHeaders = {
    'Content-Type': 'application/json'
}

// cacheApi ฝั่ง server ต้องการ Firebase ID token (Authorization: Bearer) แล้ว x-api-key อย่างเดียวไม่พอ
// หน้า report เปิดจากลิงก์โดยไม่มี session จึง sign in ด้วย account กลางก่อน (pattern เดียวกับ store อื่น)
const ensureSignedIn = async () => {
    if (!firebase.auth().currentUser) {
        await ensureReportAuth()
    }
    return firebase.auth().currentUser
}

const getAuthHeaders = async () => {
    try {
        const currentUser = await ensureSignedIn()
        if (currentUser) {
            const token = await currentUser.getIdToken()
            return Object.assign({}, baseHeaders, { Authorization: `Bearer ${token}` })
        }
    } catch (error) {
        console.log('Error getting auth token:', error)
    }
    return baseHeaders
}

export const getCompany = async (company:string) => {
    console.log("company",company)
    const response = await axios.post(`https://getcompany-bv43tjyzrq-uc.a.run.app`, {company:company}, {headers: await getAuthHeaders()})
    console.log("response",response)
    return response.data
}

export const getTeamByCompany = async (company:string) => {
    
    const response = await axios.post(`https://getteamall-bv43tjyzrq-uc.a.run.app`, {company:company}, {headers: await getAuthHeaders()})
    return response.data
}

export const getByTeam = async (team_id:string) => {
    const response = await axios.post(`https://getteam-bv43tjyzrq-uc.a.run.app`, {team:team_id}, {headers: await getAuthHeaders()})
    return response.data
}

export const getExcelsDetail = async () => {

    const response = await axios.post(`https://getexceldetails-bv43tjyzrq-uc.a.run.app`, '', {headers: await getAuthHeaders()})
    return response.data
}

const INSIGHTS_USERS_BY_COMPANY_URL = 'https://us-central1-people2-admin.cloudfunctions.net/insightsUsersByCompany'

// อ่าน users ของบริษัทผ่าน server แทน `ref('users').orderByChild('company')` ตรง
// (RTDB rules scope per-company กับ whole-node query ไม่ได้ → ให้ server อ่านแทน แล้ว
// scope ตาม company ที่อยู่ใน token). คืน object keyed ด้วย emailKey เหมือน query เดิม
export const getUsersByCompany = async (company:string) => {
    await ensureReportAuth()
    const currentUser = firebase.auth().currentUser
    const idToken = currentUser ? await currentUser.getIdToken() : ''
    const response = await axios.post(INSIGHTS_USERS_BY_COMPANY_URL, {company: company}, {
        headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
        timeout: 20000,
    })
    return response.data || {}
}

export const getUserAll = async (company:string) => {
    try {
        const response = await axios.post(`https://getuserall-bv43tjyzrq-uc.a.run.app`, {company:company}, {headers: await getAuthHeaders()})
        return response.data
    } catch (error) {
        // cacheApi ยอมรับเฉพาะ console session → report session ใช้ BFF ที่ scope company จาก token
        console.log('getUserAll: cache API rejected, falling back to insightsUsersByCompany', error)
        return getUsersByCompany(company)
    }
}

export const getByUser = async (email:string) => {
    const response = await axios.post(`https://getuser-bv43tjyzrq-uc.a.run.app`, {email:email}, {headers: await getAuthHeaders()})
    return response.data
}

export const getByQuestion = async (question_id:any) => {
    const response = await axios.post(`https://getquestion-bv43tjyzrq-uc.a.run.app`, {id:question_id}, {headers: await getAuthHeaders()})
    return response.data
}

export const getCategory = async () => {
    const response = await axios.post(`https://getcategories-bv43tjyzrq-uc.a.run.app`, '', {headers: await getAuthHeaders()})
    return response.data
}

//เอาเฉพาะ company main
export const getQustionAll = async () => {
    const response = await axios.post(`https://getquestions-bv43tjyzrq-uc.a.run.app`, '', {headers: await getAuthHeaders()})
    return response.data
}

export const getHerePoint = async (company:string,statusrowValues: any[],date:string) => {
    const response = await axios.post(`https://getherepoint-bv43tjyzrq-uc.a.run.app`, {
        "where": [
          {"field": "company", "operator": "==", "value": company},  
          {"field": "statusrow", "operator": "in", "value": statusrowValues},
          {"field": "date", "operator": ">=", "value": date}
        ]
      }, {headers: await getAuthHeaders()})
     // console.log('response',response.data)
    return response.data
}

export const getEngagementIndexDay = async (company:string, startDate:string, endDate:string) => {
    try {
        const response = await axios.post(`https://getengagementindexday1row-bv43tjyzrq-uc.a.run.app`, {
            "where": [
              {"field": "company", "operator": "==", "value": company},
              {"field": "date", "operator": ">=", "value": startDate},
              {"field": "date", "operator": "<=", "value": endDate},
            ]
          }, {headers: await getAuthHeaders()})
        if (!response.data || Object.keys(response.data).length === 0) {
            return {};
        }
        
        // console.log('Engagement Index Day Data:', processEngagementData(response.data))
        return processEngagementData(response.data);
    } catch (error) {
        console.log('Error fetching engagement index day:', error);
        throw error;
    }
}
